import {CompanyNewsTile, QueryCompanyNewsArgs} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"

import companyNews, {companyNewsKey} from "../services/queries/CompanyNews"

export const useCompanyNews = createUseQuery<CompanyNewsTile[], QueryCompanyNewsArgs>(companyNews, {
  key: companyNewsKey
})
